import styled from 'styled-components';

import {
  CheckboxIndicator,
  pressableControlLifecycleStyles,
} from '../../../shared/ui';

type LoginConsentItemProps = {
  checked: boolean;
  label: string;
  onChange: (next: boolean) => void;
};

const ConsentRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.scale.px(8)};
  font-size: ${({ theme }) => theme.scale.px(12)};
  font-weight: 400;
`;

const ConsentIndicatorLabel = styled.label`
  ${pressableControlLifecycleStyles};
  position: relative;
  display: grid;
  place-content: center;
  flex: 0 0 auto;
`;

const ConsentCheckboxInput = styled.input`
  position: absolute;
  opacity: 0;
  width: ${({ theme }) => theme.scale.px(1)};
  height: ${({ theme }) => theme.scale.px(1)};
  margin: 0;
  pointer-events: none;
`;

const ConsentText = styled.span`
  line-height: ${({ theme }) => theme.scale.px(17)};
  user-select: none;
  -webkit-user-select: none;
`;

export function LoginConsentItem({
  checked,
  label,
  onChange,
}: LoginConsentItemProps) {
  return (
    <ConsentRow>
      <ConsentIndicatorLabel>
        <ConsentCheckboxInput
          type="checkbox"
          checked={checked}
          aria-label={label}
          onChange={event => onChange(event.target.checked)}
        />
        <CheckboxIndicator checked={checked} />
      </ConsentIndicatorLabel>
      <ConsentText>{label}</ConsentText>
    </ConsentRow>
  );
}
